<script>
import {
  mapActions
} from 'vuex'

export default {
  name: 'SettingsControls',
  data() {
    return {
      control_value: this.setting.value
    }
  },
  methods: {
    ...mapActions([
      'set_component_setting'
    ]),
    update_setting(value) {
      this.set_component_setting({
        value: value,
        component_id:
        this.component_id,
        setting_id: this.id
      })
    }
  },
  props: {
    component_id: {type: String, default: () => 'No View ID!'},
    id: {type: String, default: () => 'No ID in SettingControl'},
    setting: {type: Object, default: () => { return {} }}
  }
}
</script>

<template>
<div class='d-flex'>
  <v-switch v-if='setting.type == SettingTypes.Bool'
    v-model='control_value' @change='update_setting'
    :component_id='component_id' hide-details/>

  <candela-discrete-palette-picker
    v-if='setting.type == SettingTypes.ColorDiscrete'
    @change='update_setting' :setting='setting' :component_id='component_id'/>

  <candela-color-spectrum-picker
    v-if='setting.type == SettingTypes.ColorContinuous'
    @change='update_setting' :setting='setting' :component_id='component_id'/>

  <candela-color-picker
    v-if='setting.type == SettingTypes.ColorSingle'
      @change='update_setting' :setting='setting' :component_id='component_id'/>

  <v-select
    v-if='setting.type == SettingTypes.Enum'
    :items='setting.options' v-model='control_value' @change='update_setting'
    :component_id='component_id' class='half-width'/>

  <v-slider
    v-if='setting.type == SettingTypes.NumberContinuous'
    v-model='control_value' @input='update_setting'
    :min='setting.min' :max='setting.max' :step='setting.step'
    :component_id='component_id' class='full-width'
    always-dirty hide-details thumb-label/>

  <v-range-slider
    v-if='setting.type == SettingTypes.NumberRange'
    v-model='control_value' @input='update_setting'
    :min='setting.range[0]' :max='setting.range[1]' :step='setting.step'
    :component_id='component_id' class='full-wdith'
    always-dirty hide-details thumb-label/>

  <v-text-field v-if='setting.type == SettingTypes.NumberDiscrete'
    v-model='control_value' @input='update_setting' type='number' :min='setting.min'
    :max='setting.max' class='pa-0 ma-0 half-width' dense/>
</div>
</template>

<style lang='sass' scoped>
.half-width
  flex: 1 0 !important

.full-width
  flex: 1 0 100% !important

.v-input--selection-controls.v-input
  margin: 0

.v-select
  padding: 0
  margin: 0
</style>
